<template>
  <bg-card class="program-information">
    <bg-text size="title-5" class="bg-u-text-flirt-500">
      1. Informasi Program
    </bg-text>

    <bg-divider class="bg-u-my-md" />

    <bg-field
      label="Banner Program"
      optional
      optional-label-text="(Opsional)"
      message="Maks. 2 MB"
    >
      <bg-image-uploader
        :box-height="120"
        :box-width="160"
        :progress="100"
        :initial-image-url="initialBannerUrl"
        trigger-title="Upload di sini"
        @upload="handleBannerUpload"
        @delete="handleBannerDelete"
      />
    </bg-field>

    <bg-field label="Nama Program">
      <bg-input
        :value="value.name"
        placeholder="Masukkan nama program"
        @input="emitUpdate('name', $event)"
      />
    </bg-field>

    <rich-text-area
      :value="value.description"
      label="Deskripsi Program"
      placeholder="Tulis deskripsi program..."
      :max-length="1000"
      :disabled="disabled"
      @input="emitUpdate('description', $event)"
    />

    <div class="flex gap-sm">
      <bg-field label="Tanggal Mulai" class="flex-1">
        <bg-datepicker
          id="date-picker-start"
          placeholder="Pilih tanggal mulai"
          :value="value.startDate"
          :disabled-dates="startDisabledDates"
          format="dd MMMM yyyy"
          @input="handleStartDateChange"
        />
      </bg-field>

      <bg-field label="Tanggal Berakhir" class="flex-1">
        <bg-datepicker
          id="date-picker-end"
          placeholder="Pilih tanggal berakhir"
          :value="value.endDate"
          :disabled="!value.startDate"
          :disabled-dates="endDisabledDates"
          format="dd MMMM yyyy"
          @input="emitUpdate('endDate', $event)"
        />
      </bg-field>
    </div>

    <bg-field
      label="Jumlah Kuota Program"
      optional
      optional-label-text="(Opsional)"
    >
      <bg-input
        :value="value.quota"
        placeholder="Masukkan jumlah kuota"
        @input="emitUpdate('quota', onlyNumber($event))"
      />
    </bg-field>
  </bg-card>
</template>

<script>
import {
  BgCard,
  BgText,
  BgDivider,
  BgField,
  BgInput,
  BgDatepicker,
  BgImageUploader,
} from 'bangul-vue';

import { computed } from '@vue/composition-api';

import RichTextArea from '@admin/components/molecules/RichTextArea/RichTextArea.vue';
import { onlyNumber, dayjs } from '@/utils/formatter';

export default {
  name: 'ProgramInformation',

  components: {
    BgCard,
    BgText,
    BgDivider,
    BgField,
    BgInput,
    BgDatepicker,
    BgImageUploader,
    RichTextArea,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
    // Read-only mode (e.g. an ended program); forwarded to the rich text editor
    // (other fields are disabled by the parent <fieldset>).
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const initialBannerUrl =
      typeof props.value.banner === 'string' ? props.value.banner : '';

    const minStartDate = computed(() => dayjs().startOf('day').toDate());

    const minEndDate = computed(
      () => props.value.startDate || minStartDate.value
    );

    const startDisabledDates = computed(() =>
      props.disabled ? {} : { to: minStartDate.value }
    );

    const endDisabledDates = computed(() =>
      props.disabled ? {} : { to: minEndDate.value }
    );

    const emitUpdate = (key, val) => {
      emit('input', { ...props.value, [key]: val });
    };

    const handleStartDateChange = startDate => {
      const next = { ...props.value, startDate };

      // Clear an end date that the new start date has moved past.
      if (
        props.value.endDate &&
        startDate &&
        dayjs(props.value.endDate).isBefore(dayjs(startDate), 'day')
      ) {
        next.endDate = null;
      }

      emit('input', next);
    };

    const handleBannerUpload = file => {
      emitUpdate('banner', file);
    };

    const handleBannerDelete = () => {
      emitUpdate('banner', null);
    };

    return {
      onlyNumber,
      initialBannerUrl,
      minStartDate,
      minEndDate,
      startDisabledDates,
      endDisabledDates,
      emitUpdate,
      handleStartDateChange,
      handleBannerUpload,
      handleBannerDelete,
    };
  },
};
</script>
